var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_2384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1451 9.04083L16.0641 8.01183L12.9011 1.59982C12.8092 1.44368 12.6781 1.31425 12.5207 1.22432C12.3634 1.1344 12.1853 1.0871 12.0041 1.0871C11.8229 1.0871 11.6449 1.1344 11.4875 1.22432C11.3302 1.31425 11.1991 1.44368 11.1071 1.59982L7.93814 8.01183L0.857139 9.04083C0.672479 9.06748 0.498959 9.14526 0.356195 9.26538C0.213431 9.3855 0.107117 9.54316 0.0492738 9.72054C-0.00856983 9.89792 -0.0156366 10.0879 0.0288724 10.2691C0.0733813 10.4503 0.167691 10.6154 0.301139 10.7458L5.42614 15.7398L4.21714 22.7928C4.18563 22.9767 4.2062 23.1658 4.27652 23.3386C4.34684 23.5114 4.46411 23.6611 4.61507 23.7708C4.76603 23.8804 4.94465 23.9457 5.13075 23.9591C5.31685 23.9725 5.50299 23.9337 5.66814 23.8468L12.0011 20.5178L18.3341 23.8468C18.4993 23.9337 18.6854 23.9725 18.8715 23.9591C19.0576 23.9457 19.2362 23.8804 19.3872 23.7708C19.5382 23.6611 19.6554 23.5114 19.7258 23.3386C19.7961 23.1658 19.8166 22.9767 19.7851 22.7928L18.5761 15.7398L23.7011 10.7458C23.8345 10.6156 23.9289 10.4506 23.9735 10.2696C24.0181 10.0885 24.0112 9.89862 23.9536 9.72129C23.896 9.54396 23.7899 9.38628 23.6474 9.26603C23.5049 9.14579 23.3316 9.06779 23.1471 9.04083H23.1451Z",
    fill: "#FCD420"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_2384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.5b5ac609ed4eae72fb3b7845be0967d3.svg";
export { ForwardRef as ReactComponent };